import type { MouseEvent } from 'react';
import React from 'react';
import { Block, Typography } from '@klp/design';
import { IconName, Illustration } from '@klp/design/Illustrations';
import type { Theme } from '@material-ui/core';
import { ListItem, ListItemText } from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router';
import { LeverandorRoutes } from '../../config';
import { useKlpStyles } from '@klp/design/Theme/useKlpStyles';
import { FileDownload } from '@klp/filedownload';

export type HideLeverandorOptionsElementType = 'detaljer';

export type MenuPopperLeverandorOptionsProps = {
    prosessInstansId: string | undefined;
    prosessNavn: string | undefined;
    selectedElement?: HideLeverandorOptionsElementType;
};
const styles = (theme: Theme) => ({
    iconContainer: {
        display: 'flex',
        alignItems: 'center',
        paddingRight: theme.spacing(2),
    },
});

export const MenuPopperLeverandorOptions = ({
    prosessInstansId,
    prosessNavn,
    selectedElement,
}: MenuPopperLeverandorOptionsProps) => {
    const classes = useKlpStyles({}, styles);
    const { t } = useTranslation();
    const history = useHistory();

    const handleShowLeverandorSchema = (event: MouseEvent<HTMLDivElement>) => {
        event.stopPropagation();
        if (!prosessInstansId) return;
        history.push(LeverandorRoutes.leverandorSchemaSingle(prosessInstansId));
    };

    const path = LeverandorRoutes.download(prosessInstansId);
    const fileName = `${prosessNavn}.pdf`;

    return (
        <>
            <ListItem
                dense={true}
                button={true}
                onClick={handleShowLeverandorSchema}
                selected={selectedElement === 'detaljer'}
            >
                <Block className={classes.iconContainer}>
                    <Illustration icon={IconName.CIRCLE_INFO} />
                </Block>
                <ListItemText>
                    <Typography>
                        {t(
                            'leverandor.table.actionMenuItems.visLeverandorSkjema',
                        )}
                    </Typography>
                </ListItemText>
            </ListItem>

            <ListItem dense={true} button={true} onClick={() => {}}>
                <Block className={classes.iconContainer}>
                    <Illustration icon={IconName.DOWNLOAD} />
                </Block>
                <ListItemText>
                    <FileDownload path={path} name={fileName} preview={false}>
                        {t('leverandor.table.actionMenuItems.lastNedDokument')}
                    </FileDownload>
                </ListItemText>
            </ListItem>
            <ListItem dense={true} button={true} onClick={() => {}}>
                <Block className={classes.iconContainer}>
                    <Illustration icon={IconName.SEARCH} />
                </Block>
                <ListItemText>
                    <FileDownload path={path} name={fileName} preview={true}>
                        {t(
                            'leverandor.table.actionMenuItems.forhaandsvisDokument',
                        )}
                    </FileDownload>
                </ListItemText>
            </ListItem>
        </>
    );
};
